export interface AiUsageModel {
  amountIc: number;
  displayIc: number;
}

export enum ImprvCoinAcquisitionKind {
  PURCHASE = 'PURCHASE',
  BONUS = 'BONUS'
}

export enum ImprvCoinUsageRequestKind {
  RUN = 'run',
  TRANSCRIPTION = 'transcription',
  IMAGE_EDIT = 'image_edit',
  MENTORBOT_REPLY = 'mentorbot_reply',
  BLOCK_EVALUATION = 'block_evaluation'
}

export enum ImprvCoinLedgerEntryKind {
  ACQUISITION = 'ACQUISITION',
  USAGE = 'USAGE'
}

export interface ImprvCoinLedgerEntry {
  id: string;
  kind: ImprvCoinLedgerEntryKind;
  at: string;
  amount: number;
  acquisitionKind: ImprvCoinAcquisitionKind | null;
  expiresAt: string | null;
  isExpired: boolean;
  requestKind: string | null;
  agentKind: string | null;
}

export interface ImprvCoinExpiryBucket {
  expiresAt: string | null;
  remaining: number;
}

export interface ImprvCoinsLedger {
  entries: ImprvCoinLedgerEntry[];
  remaining: number;
  buckets: ImprvCoinExpiryBucket[];
}

export interface ImprvCoinsLedgerResponseModel extends ImprvCoinsLedger {
  usagesAvailable: boolean;
}

export interface ImprvCoinsPackagePriceModel {
  amount: number; // minor units (grosze), gross – VAT included
  currency: string;
}

export interface ImprvCoinsPackageModel {
  sku: string;
  quantity: number;
  price: ImprvCoinsPackagePriceModel;
  name: string;
  // exactly one package in the catalog is recommended – the UI preselects and badges it
  isRecommended: boolean;
}

export interface ImprvCoinsBalance {
  isLoaded: boolean;
  // null while unknown, so a consumer can never read "we have not asked yet" as "no coins left".
  remaining: number | null;
  usagesAvailable: boolean;
  buckets: ImprvCoinExpiryBucket[];
}

export enum ImprvCoinsWarningReason {
  LOW_BALANCE = 'LOW_BALANCE',
  EXPIRING = 'EXPIRING'
}

export interface ImprvCoinsWarning {
  reason: ImprvCoinsWarningReason;
  remaining: number;
  // Both are null when no coins expire soon.
  expiringAmount: number | null;
  expiresAt: string | null;
}

export interface BlockEvaluationCoinsGateState {
  isBalanceLoaded: boolean;
  // null until the ledger answers, so a non-number must be treated as unknown.
  remaining: number | null;
  usagesAvailable: boolean;
  isAiBackedBlock: boolean;
  isEditorMode: boolean;
  isReadOnly: boolean;
  isGameStarted: boolean;
  isEvaluationPending: boolean;
}
